// Redux Form
import { reset } from 'redux-form';

// Redux action
import { sendMessageAction } from '../../../actions/message/sendMessageAction';

async function submit(values, dispatch) {
	let threadId, threadType, type, content, startDate, endDate, reservationId, actionType, personCapacity;
	threadId = values.threadId;
	threadType = values.threadType;
	startDate = values.startDate;
	endDate = values.endDate;
	reservationId = values.reservationId;
	type = values.type;
	content = values.content;
	actionType = values.actionType;
	personCapacity = values.personCapacity;
	dispatch(sendMessageAction(
		threadId,
		threadType,
		content,
		type,
		startDate,
		endDate,
		personCapacity,
		reservationId,
		values.receiverName,
		values.senderName,
		values.receiverType,
		values.receiverEmail,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
		actionType
	));
	dispatch(reset('SendMessage'));
}

export default submit;